// v2.24 — statut d'une inscription à un collectif : un seul endroit pour le groupe ET le badge
// (avant : les élèves en essai tombaient dans « Inactifs » tout en affichant [A]).
const BADGES = {
  active:       { code: 'A', label: 'Actif',       cls: 'text-[#26A69A]' },
  trial:        { code: 'E', label: 'Essai',       cls: 'text-orange-500' },
  inactive:     { code: 'I', label: 'Inactif',     cls: 'text-amber-500' },
  not_enrolled: { code: 'N', label: 'Non inscrit', cls: 'text-slate-400' },
};
export const enrollBadge = (status) => BADGES[status || 'active'] || BADGES.active;
export const inRoleGroup = (e) => ['active', 'trial'].includes(e.status || 'active');
export const ENROLL_CHOICES = ['active', 'trial', 'inactive'];
